import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppFooter from "../../components/app-footer/AppFooter";
import UiUtils from '../../utils/UiUtils';
import ApiClient from '../../utils/ApiClient';
import DashboardNav from "./components/navbar/Navbar";

const Dashboard = () => {

        return (
            <div>
                
                <div className="wrapper">
                    <DashboardNav />

                    <div className="container-fluid">
                        
                    </div>
                </div>
                <div className="clearfix" />
                <AppFooter />
            </div>
        );
    }

Dashboard.propTypes = {
    match: PropTypes.object,
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/Dashboard.js